import { Tag as AntdTag, type TagProps } from "antd";
import styles from "./Tag.module.css";

export const Tag = ({ children, ...props }: TagProps) => {

  return (
    <AntdTag className={styles.tag} {...props}>
      {children}
    </AntdTag>
  );
};
